import {Box, Modal} from '@mui/material';
import React, {useEffect} from 'react';
import {Carousel} from 'react-responsive-carousel';
import CarousalPreviousButton from '../Resources/Images/Websvgs/CarousalPreviousButton';
import CarousalNextButton from '../Resources/Images/Websvgs/CarousalNextButton';
import './EnsoniaModal.css';
import ApiClient from '../networking/ApiManager';
import Colors from '../Resources/COLORS/Colors';
import {useTranslation} from 'react-i18next';
import IntroductionModelBackgroundAssets from '../newSychart/resource/svg/IntroductionModelBackgroundAssets';

const ArabicIntrodModal = ({isOpen, setIsOpen, id, platformPrimaryColor}) => {
  const [activeIndex, setActiveIndex] = React.useState(0);
  const [introductionData, setIntroductionData] = React.useState([]);
  const [logoImage, setLogoImage] = React.useState('');
  const crousalRef = React.useRef(null);
  const {t} = useTranslation();

  const indexNum = () => {
    const currentIndex = (activeIndex % introductionData.length) + 1;
    const reversedIndex = introductionData.length - currentIndex + 1;
    return reversedIndex;
  };

  useEffect(() => {
    setActiveIndex(introductionData.length - 1);
  }, [isOpen, introductionData, id]);

  useEffect(() => {
    ApiClient.getIntroductionData(id)
      .then(res => {
        const resData = res.data.data.reverse();
        setLogoImage(resData[0].hospital_logo_url);
        setIntroductionData(resData);
      })
      .catch(err => {
        console.log('err', err);
      });
  }, [id]);

  const renderSections = (item, i) => {
    const smallFont = item.description.length < 515 ? 14 : 12.6;
    const smallModelDesign = item.description.length < 301;
    const maxHeightDes = smallModelDesign ? 195 : 300;
    const hideDes = item.description.length === 0;

    return (
      <>
        <div
          style={{
            direction: 'rtl',
          }}
          key={i}
          className="section">
          <div className="image-container">
            <img src={item.image_url} className="models-image" alt="carousal" />
          </div>
          <h1
            style={{
              marginTop: 20,
              marginBottom: 15,
            }}
            className="title">
            {item.title}
          </h1>

          <div className="model-description">
            <div
              style={{
                fontSize: smallFont,
                maxHeight: !!hideDes ? 0 : maxHeightDes,
                height: !!hideDes ? 0 : null,
              }}
              className={`model-description-content ${
                i !== 0 ? 'previousModel' : 'lastModel'
              }`}
              dangerouslySetInnerHTML={{__html: item.description}}
            />
          </div>
        </div>
        {i === 0 && (
          <button
            className="model-close-button"
            onClick={() => {
              setIsOpen(false);
            }}>
            {t('begin_sy_chart')}
          </button>
        )}
      </>
    );
  };

  const backgroundStyle = () => {
    return (
      <div className="background-model">
        <img
          src={logoImage}
          alt="novaBenefitsLogo"
          className="nova-arabic-logo-modal"
        />
        <IntroductionModelBackgroundAssets
          className="arModalLeftBackgroundElement"
          platformPrimaryColor={platformPrimaryColor}
        />
        <IntroductionModelBackgroundAssets
          className="arModalRightBackgroundElement"
          platformPrimaryColor={platformPrimaryColor}
        />
      </div>
    );
  };

  const renderIdicator = () => {
    const isPrevButtonDisabled = activeIndex === 0;
    const isNextButtonDisabled = activeIndex === introductionData.length - 1;
    const prevButtonStroke = isPrevButtonDisabled ? Colors.GREY : Colors.WHITE;
    const nextButtonStopColor = isNextButtonDisabled
      ? Colors.GREY
      : platformPrimaryColor;

    return (
      <div className="model-buttons">
        <div className="model-indicator">
          <div className="model-back-button">
            <div
              onClick={handleBackClick}
              className={
                isPrevButtonDisabled
                  ? 'none model-button-icon-container-disabled'
                  : 'model-button-icon-container'
              }>
              <CarousalNextButton
                className="model-next-button-icon"
                prev
                stopColor={prevButtonStroke}
                disabled={isPrevButtonDisabled}
                style={{transform: 'scaleX(-1)'}}
              />
              <div
                className="model-previous-button-title"
                style={{
                  color: prevButtonStroke,
                }}>
                {t('question_next')}
              </div>
            </div>
          </div>
          <div className="modelIndex">
            {introductionData.length + '/' + indexNum()}
          </div>
          <div className="model-next-button">
            <div
              onClick={handleNextClick}
              className={
                isNextButtonDisabled
                  ? 'model-previous-button-icon-container-disabled'
                  : 'model-previous-button-icon-container'
              }>
              <div
                className="model-next-button-title"
                style={{
                  color: nextButtonStopColor,
                }}>
                {t('back')}
              </div>
              <CarousalPreviousButton
                style={{transform: 'scaleX(-1)'}}
                className="model-previous-button-icon"
                stroke={nextButtonStopColor}
                disabled={isNextButtonDisabled}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleBackClick = () => {
    setActiveIndex(prevIndex => Math.max(prevIndex - 1, 0));
  };

  const handleNextClick = () => {
    setActiveIndex(prevIndex =>
      Math.min(prevIndex + 1, introductionData.length - 1),
    );
  };

  if (!introductionData.length) return null;

  return (
    <Modal className="model" open={isOpen}>
      <Box
        sx={{
          direction: 'initial',
        }}
        className="nova-model">
        {backgroundStyle()}
        <Carousel
          key={`carousel-${activeIndex}`}
          ref={crousalRef}
          selectedItem={activeIndex}
          swipeable={false}
          showStatus={false}
          showThumbs={false}
          onChange={setActiveIndex}
          showIndicators={false}
          renderArrowNext={() => null}>
          {introductionData.map(renderSections)}
        </Carousel>
        {renderIdicator()}
      </Box>
    </Modal>
  );
};
export default ArabicIntrodModal;
